import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { type FlowLlmPromptBlock } from 'flow-schema';

import { isDefined } from 'common';

import { DialogCloseButton } from '../../../../../../../../components/DialogCloseButton';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';
interface FileReferenceDialogProps {
  onClose: () => void;
  fileReferencesIndex: number | undefined;
}

export function FileReferenceDialog(props: FileReferenceDialogProps) {
  const { onClose, fileReferencesIndex } = props;
  const { value: fileReferences, setValue: setFileReferences } =
    useSelectedNodeField<FlowLlmPromptBlock['config']['fileReferences']>('config.fileReferences');
  const onCancel = () => {
    if (!isDefined(fileReferencesIndex)) {
      return;
    }
    setFileReferences(fileReferences?.filter((_, index) => index !== fileReferencesIndex));
    onClose();
  };
  return (
    <Dialog open={isDefined(fileReferencesIndex)} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Use File ID</DialogTitle>
      <DialogCloseButton onClose={onCancel} />
      <DialogContent>
        <BlockValueTemplateField
          label="File reference"
          fieldName={`config.fileReferences.${fileReferencesIndex}`}
          helperText="A string in the format {type}:{identifier}."
        />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={() => onCancel()}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => onClose()}>
          Add file ID
        </Button>
      </DialogActions>
    </Dialog>
  );
}
